<div class="page-container">
  <div class="header">
    <p class="subtitle">View and manage feed exclusion and override status</p>
  </div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

  <div *ngIf="!loading">
    <table mat-table [dataSource]="rows" class="data-table">

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef> Product </th>
        <td mat-cell *matCellDef="let row">
          <span class="product-name">{{ row.name }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef> Destination </th>
        <td mat-cell *matCellDef="let row">
          <span class="badge" [class.badge-primary]="row.destination_code">
            {{ row.destination_code }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="excluded">
        <th mat-header-cell *matHeaderCellDef> Excluded </th>
        <td mat-cell *matCellDef="let row">
          <span class="badge" [class.badge-warn]="row.is_excluded">
            {{ row.is_excluded ? 'Yes' : 'No' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="overrides">
        <th mat-header-cell *matHeaderCellDef> Overrides </th>
        <td mat-cell *matCellDef="let row">
          <span class="badge" [class.badge-primary]="row.has_overrides">
            {{ row.has_overrides ? 'Yes' : 'No' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-stroked-button color="primary" [routerLink]="['/admin/feeds/product', row.product_id]">
            Manage Overrides
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>
  </div>
</div>
